
import type { BaseErrorResponse, GetResourceUrlReq, GetResourceUrlRes } from './data-contracts';
import type { RequestParams } from './http-client';
import { ContentType, HttpClient } from './http-client';


export default function useMetabase() {
  class Metabase<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
    /**
     * No description
     *
     * @tags Metabase
     * @name MetabaseControllerGetResourceUrl
     * @summary Getting a link to the report in metabase
     * @request POST:/api3/metabase/resources/{resourceKey}/{resourceId}/get-url
     * @secure
     * @response `200` `GetResourceUrlRes`
     * @response `400` `BaseErrorResponse`
     */
    metabaseControllerGetResourceUrl = (
      resourceKey: string,
      resourceId: number,
      data: GetResourceUrlReq,
      params: RequestParams = {},
    ) =>
      this.request<GetResourceUrlRes, BaseErrorResponse>({
        path: `/api3/metabase/resources/${resourceKey}/${resourceId}/get-url`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });
  }

  return new Metabase();
}
